var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
export var TableSectionFragment = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment TableSectionFragment on TableSection {\n    ... on TableSection {\n      tableContent: content {\n        label\n        content\n      }\n    }\n  }\n"], ["\n  fragment TableSectionFragment on TableSection {\n    ... on TableSection {\n      tableContent: content {\n        label\n        content\n      }\n    }\n  }\n"])));
export default {};
var templateObject_1;
